'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFieldSubmit = exports.isWatchedEntity = undefined;

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

exports.handleAuth = handleAuth;
exports.handleLogout = handleLogout;
exports.handleProfileField = handleProfileField;
exports.handleEntityPut = handleEntityPut;
exports.handleTriplePut = handleTriplePut;

var _capeLodash = require('cape-lodash');

var _reduxField = require('redux-field');

var _reduxGraph = require('redux-graph');

var _capeSelect = require('cape-select');

var _handler = require('./handler');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleAuth(_ref) {
  var firebase = _ref.firebase,
      store = _ref.store;
  var auth = firebase.auth,
      googleAuth = firebase.googleAuth;
  // console.log(credential)

  return auth.signInWithPopup(googleAuth).then((0, _flow3.default)((0, _get3.default)('user'), (0, _handler.loginUser)(firebase, store)));
}
function handleLogout(_ref2) {
  var auth = _ref2.firebase.auth,
      action = _ref2.action,
      next = _ref2.next;

  return auth.signOut().then(next(action));
}
function handleProfileField(_ref3) {
  var firebase = _ref3.firebase,
      _ref3$store = _ref3.store,
      dispatch = _ref3$store.dispatch,
      getState = _ref3$store.getState,
      action = _ref3.action,
      next = _ref3.next;

  next(action);
  var state = getState();
  var entityPath = action.meta.prefix;
  var entity = (0, _flow3.default)(_reduxGraph.selectGraph, (0, _get3.default)(entityPath))(state);
  var fieldId = (0, _reduxField.fieldValue)(entityPath, 'id')(state);
  var update = (0, _capeLodash.set)(entity, fieldId, action.payload);
  (0, _util.entityUpdate)(firebase, update).then(function () {
    return dispatch((0, _reduxField.clear)(entityPath));
  });
}
var isWatchedEntity = exports.isWatchedEntity = (0, _capeSelect.simpleSelector)((0, _get3.default)('action.meta.prefix[0]'), (0, _get3.default)('entityIds'), _get3.default);

var handleFieldSubmit = exports.handleFieldSubmit = (0, _cond3.default)([[isWatchedEntity, handleProfileField], [_stubTrue3.default, _util.nextAction]]);
function handleEntityPut(_ref4) {
  var firebase = _ref4.firebase,
      action = _ref4.action,
      next = _ref4.next;

  next(action);
  return (0, _util.entitySet)(firebase, action.payload);
}
function handleTriplePut(_ref5) {
  var firebase = _ref5.firebase,
      action = _ref5.action,
      next = _ref5.next;

  next(action);
  return (0, _util.triplePut)(firebase, action);
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/~/cape-firebase/lib/actionHandlers.js
// module id = 361
// module chunks = 0